export default {
  apiURL: 'https://nipoges.fcul.cors.digital',
  websiteURL: 'https://ameijoajaponesa.com',
  languages: ['pt'],
  listSize: 9,
  defaultLang: 'pt',
};
